import './set-public-path'
import './style/commons.scss'
import Breadcrumb from './components/menus/Breadcrumb'
import DropdownMenu from './components/menus/DropdownMenu'
import CheckboxInput from './components/form/CheckboxInput'
import MultiStateCheckboxInput from './components/form/MultiStateCheckboxInput'
import { INPUT_TYPE } from './models/form'
import PaginatedGallery from './components/media/PaginatedGallery'
import PhotoCard from './components/media/PhotoCard'
import FiltersBar from './components/menus/FiltersBar'
import BadgeIcon from './components/data/BadgeIcon'
import BadgeLabel from './components/data/BadgeLabel'
import BadgePositioned from './components/data/BadgePositioned'
import ChipFilteredContent from './components/data/ChipFilteredContent'
import LuxButton from './components/buttons/Button'
import Heading from './components/text/Heading'
import Text from './components/text/Text'
import { LuxDialog } from './components/messages/dialog/Dialog'
import { AlertDialog } from './components/messages/dialog/ConfirmDialog'
import { FormDialog } from './components/messages/dialog/FormDialog'
import LuxDataTable from './components/data/LuxDataTable'
import { TEMPLATE_TYPE } from './models/data'
import AlertDialogBuilder from './models/dialog'
import LuxTabs from './components/tabs/Tabs'
import LuxToast from './components/messages/LuxToast'
import LoadingCircle from './components/misc/LoadingCircle'
import { useWindowResize } from './utils/hooks'
import FormInput from './components/form/FormInput'
import InputWrapper from './components/form/form-inputs/InputWrapper'
import TextInput from './components/form/form-inputs/TextInput'
import MultiSelect from './components/form/form-inputs/MultiSelect'
import DatePicker from './components/form/form-inputs/DatePicker'
import AreaInput, { AREAINPUT_MODE } from './components/form/AreaInput'
import FileInput from './components/form/FileInput'
import LuxIcon from './components/icons/LuxIcon'
import LuxTextIcon from './components/icons/LuxTextIcon'
import LuxSteps from './components/menus/Steps'
import ColorPicker from './components/form/ColorPicker'
import RadioInput from './components/form/RadioInput'
import MainCalendar from './components/data/MainCalendar'
import LightboxGallery from './components/media/LightboxGallery'
import packageJson from '../package.json'
import LuxPDFViewer from './components/pdf/PDFViewer'
import LuxTree from './components/tree/Tree'
import DataColumns from './components/columns/Columns'
import SelectableData from './components/data/SelectableData'
import Select from './components/form/form-inputs/Select'

console.log(
    '%c' +
        packageJson.name +
        ' v' +
        packageJson.version +
        ' - ENVIRONMENT: ' +
        process.env.REACT_APP_ENV +
        ' - BUILD_TYPE: ' +
        process.env.NODE_ENV,
    'background: #1EC08D; color: white; font-size: 12px; padding: 5px;'
)

// Anything exported from this file is importable by other in-browser modules.
export function publicApiFunction() {}

// CUSTOM LUX COMPONENTS
// area input
export { AREAINPUT_MODE }
// buttons
export { LuxButton }
// charts
// data
export {
    BadgeIcon as LuxBadgeIcon,
    BadgeLabel as LuxBadgeLabel,
    BadgePositioned as LuxBadgePositioned,
    ChipFilteredContent as LuxChipFilteredContent,
    LuxDataTable,
    TEMPLATE_TYPE as LUX_TEMPLATE_TYPE,
    MainCalendar as LuxMainCalendar,
    DataColumns as LuxDataColumns,
    SelectableData as LuxSelectableData,
}
// form
export {
    CheckboxInput as LuxCheckboxInput,
    MultiStateCheckboxInput as LuxMultiStateCheckboxInput,
    INPUT_TYPE as LUX_INPUT_TYPE,
    FormInput as LuxFormInput,
    DatePicker as LuxDatePicker,
    AreaInput as LuxAreaInput,
    FileInput as LuxFileInput,
    RadioInput as LuxRadioInput,
    ColorPicker as LuxColorPicker,
    InputWrapper as LuxInputWrapper,
    TextInput as LuxTextInput,
    MultiSelect as LuxMultiSelect,
    Select as LuxSelect,
}
// icons
export { LuxIcon, LuxTextIcon }
// media
export {
    LightboxGallery as LuxLightboxGallery,
    PhotoCard,
    PhotoCard as LuxPhotoCard,
    PaginatedGallery,
}
// menus
export {
    Breadcrumb as LuxBreadcrumb,
    FiltersBar as LuxFiltersBar,
    LuxTabs as LuxTabs,
    DropdownMenu as LuxDropdownMenu,
    LuxSteps,
}
// messages
export {
    AlertDialog as LuxAlertDialog,
    AlertDialogBuilder,
    FormDialog as LuxFormDialog,
    LuxDialog,
    LuxToast,
}
// misc
export { LoadingCircle as LuxLoadingCircle }
// overlay
// panels
// pdf
export { LuxPDFViewer as LuxPDFViewer }
// text
export { Heading as LuxHeading, Text as LuxText }
// tree
export { LuxTree }
// utils
export { useWindowResize }
